export default {"src":"/_next/static/media/sales-qualification-tools-icon.ac80f2fa.svg","height":49,"width":49};